import styled from "styled-components";
import { colors } from "styles/colors";
import { fonts } from "styles";
import { Trash } from "styles/styled-components";

export {
  ButtonMini,
  BoxContainer,
  FormRow,
  Loading,
} from "styles/styled-components";

export const Container = styled.section`
  width: 100%;

  form {
    margin-bottom: 24px;
  }

  button.add {
    width: 50px;
    height: 50px;
    min-width: 50px;
    padding: 0;
    font-size: 28px;
    line-height: 1;
  }
`;

export const Title = styled.h2`
  margin-bottom: 8px;
`;

export const ButtonContainerCreate = styled.div`
  padding-top: 25px;
`;

export const GridContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const EmptyState = styled.article`
  font-size: 14px;
  color: ${colors.gray3};
`;

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ItemContent = styled.div`
  width: 100%;
  padding: 16px;
  background-color: ${colors.white};
  border-radius: 4px;
  box-shadow: 2px 2px 3px 2px rgba(0, 0, 0, 0.15);
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 16px;
`;

export const ItemValue = styled.span`
  font-family: ${fonts.GilroySemiBold};
  font-size: 12px;
  color: ${colors.gray4};
`;

export const ButtonIcon = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconDelete = styled(Trash).attrs({ size: 24 })<{
  disabled?: boolean;
}>`
  color: ${({ disabled }) => (!disabled ? colors.red : colors.gray3)};
  cursor: ${({ disabled }) => (!disabled ? "pointer" : "not-allowed")};
`;
